module.exports = __webpack_public_path__ + "img/span-icon2.725d6fe9.png";